import jsonIcon from '@/assets/json.svg';

export const JsonIcon = () => <img src={jsonIcon} alt="JSON Icon" className="w-4 h-4 mr-2" />;
